import createReactComponent from '../createReactComponent';
var TrendingUp = createReactComponent('TrendingUp', [['polyline', {
  points: '23 6 13.5 15.5 8.5 10.5 1 18',
  key: '1koq6b'
}], ['polyline', {
  points: '17 6 23 6 23 12',
  key: '5tkgvh'
}]]);
export default TrendingUp;